export default "__VITE_ASSET__BFTJMrYx__"